import React, {
    Component
}
    from "react";


import Collapsible from 'react-collapsible';
import Obfuscate from 'react-obfuscate';

import Separator from "@components/Separator";
import Footer from "@components/Footer";
import Contact from "@components/Contact";


import styles from "./confidentiality.module.css";
import NavigationBar from "@components/NavigationBar";


class ConfidentialityQuestions extends Component {

    render() {
        return (
            <div>
                <NavigationBar />
                <div className={styles.container_confidentiality} >
                    <h1 className="title__54px">
                        <text className="title__42px">Confidentiality </text>
                        <text className="title__42px__orange">& Security</text>
                    </h1>




                    <div>
                        <p className="text__18px"> The Human Sciences Research Council (“HSRC”) and its Centre for Science, Technology and Innovation Indicators (HSRC-CeSTII) is committed to provide you/your organisation with secure access to our <strong>
                            online survey services (“our services”)</strong>, and to ensure the confidentiality of your organisation’s information at all times.  </p>


                        <p className="text__18px__border" >
                            <strong>If I choose not to use the online survey, how do I submit my annual R&D Survey return?
                            </strong>
                            <br /><br />The annual R&D Survey questionnaire can be completed using our Adobe Acrobat PDF form (business enterprises, government, not-for-profit institutions and science councils) or MS Excel spreadsheet (higher education institutions only). Questionnaires in these formats can be returned via email or via the postal services.
                            <br /><br />
                            Write to <Obfuscate
                                email="innovation@hsrc.ac.za" /> if you require further support. We’re committed to making your experience of the R&D Survey both easy and useful.
                        </p>

                        <p className="text__18px" >
                            This confidentiality and security notice is provided to you, the user using our services on behalf of your organisation, so that you can make an informed decision as to whether or not you would like to use this website and its services.
                            <br /><br />
                            By using this website, you agree to be bound to the terms of this notice.
                            <br /><br />
                            If you do not agree to be bound by the terms of this notice, you must stop using this website immediately.
                            <br /><br />

                        </p>
                    </div>





                    <div className={styles.question_section} >
                        <div className={styles.question_div} >
                            <details>
                                <summary className="text__18px">
                                    We collect and process information for national statistical research purposes
                                </summary>
                                <p className="text__16px">
                                    The HSRC-CeSTII only collects and processes information that it is mandated to collect and process by the Department of Science and Innovation (DSI), in terms of the Statistics Act (No. 6 of 1999).
                                    <br /> <br />
                                    All information is collected and processed in terms of the Protection of Personal Information Act, Act 4 of 2013 (POPIA).
                                    <br /> <br />
                                    This includes, inter alia, information about the expenditure on research and experimental development (R&D) as well as personnel involved in R&D.
                                    <br /> <br />
                                    Information that is collected and processed by HSRC-CeSTII is used to produce nsational science, technology and innovation indicators.
                                    <br /><br />

                                    <p className="text__16px__border" >
                                        <strong>
                                            How can I access the national science, technology and innovation indicators produced by HSRC-CeSTII?
                                        </strong>
                                        The R&D Survey team produce two reports annually: a statistical report and a main analysis report. These are disseminated widely and are publically accessible on the HSRC website <a href="http://www.hsrc.ac.za/en/departments/CeSTii/reports-cestii" target="_blank">(http://www.hsrc.ac.za/en/departments/CeSTii/reports-cestii) </a>and the website of the Department of Science and Innovation <a href="http://www.dst.gov.za/publications-policies/r-d-reports" target="_blank">(http://www.dst.gov.za/publications-policies/r-d-reports)</a>.

                                    </p>
                                    <br /><br />
                                    If you are interested to learn more about the specific details of the categories of information we collect and process please go to the section <strong>
                                        <a href="#contact">How to contact us.</a></strong>
                                    <br /> <br />
                                    Some information may be collected automatically whenever you visit the site.
                                    <br /> <br />
                                    This information may include your IP address, browser and/or operating system information, the date and time you visited the website, the amount of time you spent browsing the site, your geographic location (if you have enabled this functionality on your browser), and the pages you view while using the website.
                                    <br />
                                    This information will not be shared with any third party.
                                    <br /><br />
                                    This information is only used for analytics purposes, to better understand how survey respondents are using the website and to assist the HSRC-CeSTII development team to improve our services.
                                    <br />
                                    We provide more information about the cookies we use in the section <strong><a href="#cookies">Cookies.</a></strong>
                                    <br />

                                </p>
                            </details>
                        </div>


                        <div className={styles.question_div} >
                            <details>
                                <summary className="text__18px">
                                    How we use the information we collect
                                </summary>
                                <p className="text__16px">
                                    In order for HSRC-CeSTII to meet our obligations to produce national STI indicators on behalf of the DSI, we collect information about R&D from various organisation types: businesses, not-for-profit organisations, science councils, government departments and higher education institutions.
                                    <br />   <br />

                                    We store this information in a secure database that is part of a data management system within the HSRC secure server environment.
                                    <br />
                                    This information is retained in line with S14(1) and (2) of POPIA.
                                    <br />   <br />
                                    Once collected, we extract information from the database and aggregate it in order to produce national statistics.
                                    <br />   <br />
                                    The aggregate data is curated (i.e. stored) within the HSRC’s eKnowledge Research Centre (eKRC). The data curation portal of the eKRC is available online at <strong><a href="http://datacuration.hsrc.ac.za/" target="_blank">http://datacuration.hsrc.ac.za </a></strong>
                                    <br />
                                    HSRC-CeSTII researchers as well as researchers with legitimate data requests to the HSRC-CeSTII may request to use the aggregate or anonymised unit-level data for analysis purposes. A HSRC-CeSTII data committee assesses such data requests on the basis of strict criteria aimed at ensuring confidentiality of unit-level data at all times.
                                    <br />

                                </p>
                            </details>
                        </div>

                        <div className={styles.question_div} >
                            <details>
                                <summary className="text__18px">
                                    Confidentiality of your organisation’s information
                                </summary>
                                <p className="text__16px">
                                    Unit-level information, that is information about or attributable to any single organisation, is always kept strictly confidential by HSRC-CeSTII.
                                    <br />     <br />
                                    Confidentiality is assured through various access protocols for the access of anonymised unit-level data, as well as confidentiality agreements between the HSRC and its workforce that access the unit-level data during the course of their work.
                                    <br />   <br />
                                    Through the database technology that accompanies this website, individuals based in organisations that participate in the survey may review or request to amend, or request to have their personal information removed through the data services provided. In cases where a removal is sanctioned, in order for HSRC-CeSTII to execute its mandate of collecting official R&D statistics, alternative organisational contact details should be supplied to HSRC-CeSTII by the organisation concerned.
                                    <br />   <br />
                                    You may write to the chair of the HSRC-CeSTII data committee (<Obfuscate email="cestiidata@hsrc.ac.za" />) to log any concerns or questions pertaining to the confidentiality of your organisation’s information or that of your organisation’s personnel.

                                    <br />

                                </p>
                            </details>
                        </div>


                        <div className={styles.question_div} >
                            <details>
                                <summary className="text__18px">
                                    When will we disclose information without your consent?
                                </summary>
                                <p className="text__16px">
                                    We will not disclose your information for any other purposes without your consent, except under certain circumstances.
                                    <br />
                                    All information supplied to HSRC-CeSTII or collected by us will not under any circumstances be sold or given as such to any unauthorised third parties.
                                    <br />   <br />
                                    HSRC will only disclose or report information if and when required to do so by law or any regulatory authority, to our employees, or agents who require such information to carry out their duties, and to our auditors, financial and/or statistical, so that they can perform their duties to us.
                                    <br />   <br />
                                    We will not disclose information to anyone outside HSRC without your permission unless:
                                    <br />
                                    -	we are compelled to do so by law or in terms of a court order;
                                    <br />
                                    -	it is in the public interest to do so; <br />
                                    -	it is necessary to protect our rights.
                                    <br />
                                    Access to your information held by HSRC-CeSTII may also be requested by yourself or third parties.
                                    <br />   <br />
                                    The Promotion of Access to Information Act, 2 of 2000 regulates and sets out the procedure for such a request and under what circumstances such access may be refused.

                                    <br />
                                    <br />

                                </p>
                            </details>
                        </div>



                        <div className={styles.question_div} >
                            <details>
                                <summary className="text__18px">
                                    How we store the information we collect
                                </summary>
                                <p className="text__16px">
                                    The information we collect via this website is stored in a secure environment, and is not available to any person outside HSRC and the Council for Scientific and Industrial Research (CSIR), who provide database management related technical assistance
                                    to the HSRC from time to time.
                                    <br />
                                    We store your information in perpetuity as long as: <br />
                                    -	we need it to achieve the statistical purposes set out above; <br />
                                    -	any law or contract requires us to keep the information; or <br />
                                    -	HSRC needs it for lawful purposes linked to its functions.
                                    <br /><br />
                                    Once we are no longer authorised to keep your information, we will take one of the following actions: <br />

                                    -	destroy the information; <br />
                                    -	delete the information in such a way that it cannot be recovered; or <br />
                                    -	anonymise the information in a manner that cannot be linked back to you or used to identify you.


                                    <br />
                                    <br />

                                </p>
                            </details>
                        </div>


                        <div id="cookies" className={styles.question_div} >
                            <details>
                                <summary className="text__18px">
                                    Cookies
                                </summary>
                                <p className="text__16px">
                                    On some parts of our website we use so-called “cookie” technology.
                                    <br /><br />
                                    Cookie technology consists of small pieces of data or a small text file, which is given to your browser by our web server when you visit our website.
                                    <br /><br />
                                    This data is stored on your browser.
                                    <br /><br />
                                    The cookie is sent back to our webserver each time you visit our website.
                                    <br /><br />
                                    Cookies are not computer programmes and do not run on a computer like programs do.
                                    <br /><br />
                                    They cannot gather information or function on their own.
                                    <br /><br />
                                    They cannot collect any information about you or your machine and cannot gather data or information about what you do on the Internet.
                                    <br /><br />
                                    Cookies merely enable us to provide a more valuable online experience to you.
                                    <br /><br />
                                    While you can set up your Internet browser to disable cookie technology, we do not recommend that you do this since some parts of this website and our online services may not function properly, or at all.


                                    <br />
                                    <br />

                                </p>
                            </details>
                        </div>
                        <div className={styles.question_div} >
                            <details>
                                <summary className="text__18px">
                                    Third parties
                                </summary>
                                <p className="text__16px">
                                    HSRC-CeSTII may make use of authorised open source or third party software applications, such as web secure applications, to help us to collect and process your information in order to provide an online service to you.
                                    <br /><br />
                                    Whenever we commission other organisations to provide support services to us, we will take steps to bind them to our security and confidentiality policies as far as they may be required to have access to our respondents’ information to perform such services through contractual agreements.
                                    <br /><br />
                                    Any third parties are not permitted to use the information for any other purposes beyond those for which it was collected.



                                    <br />
                                    <br />

                                </p>
                            </details>
                        </div>

                        <div className={styles.question_div} >
                            <details>
                                <summary className="text__18px">
                                    Our security practices
                                </summary>
                                <p className="text__16px">
                                    HSRC is committed to providing secure online services, which protect the confidentiality as well as the quality and integrity of your organisation’s information.
                                    <br />
                                    HSRC has implemented appropriate security measures to help it keep your information secure, accurate, current, and complete.
                                    <br /><br />
                                    As such, all interactions with our survey services website are protected through encryption that complies with international standards.
                                    <br /><br />
                                    Encryption is used to protect the transmission of your information when completing online survey forms.
                                    <br /><br />
                                    Our physical and internet-cloud servers are protected by firewalls and intrusion detection systems.
                                    <br /><br />
                                    Access to information on these servers is restricted to authorised personnel only.
                                    <br /><br />
                                    <strong>
                                        However, HSRC cannot guarantee the security of any information you transmit to it online and you do so at your own risk.
                                    </strong>




                                    <br />
                                    <br />

                                </p>
                            </details>
                        </div>


                        <div className={styles.question_div} >
                            <details>
                                <summary className="text__18px">
                                    Data breaches
                                </summary>
                                <p className="text__16px">
                                    In the event that HSRC becomes aware that your information has been compromised in any way, we will notify you and the relevant regulatory authorities as soon as reasonably possible after becoming aware of the possible compromise so that you are aware of the nature of the breach and what actions you may need to take in order to protect yourself.


                                    <br />
                                    <br />

                                </p>
                            </details>
                        </div>



                        <div className={styles.question_div} >
                            <details>
                                <summary className="text__18px">
                                    Right to amend this confidentiality and security statement
                                </summary>
                                <p className="text__16px">
                                    We reserve the right to amend this confidentiality and security statement at any time.
                                    <br /><br />
                                    When we do, we will revise the last updated date at the top of this notice.
                                    <br /><br />
                                    All amendments to this privacy and security statement will be posted on this website under the Confidentiality and Security page.
                                    <br /><br />
                                    Unless otherwise stated, the current version shall supersede and replace all previous versions of this privacy and security statement.
                                    <br /><br />
                                    It is your responsibility to check for changes each time you visit our website.
                                    <br /><br />
                                    If you use the website after any changes to this privacy notice have been made, we will accept that you are familiar with and agree to all of the changes.



                                    <br />
                                    <br />

                                </p>
                            </details>
                        </div>


                        <div className={styles.question_div} >
                            <details>
                                <summary className="text__18px">
                                    Electronic communications and records
                                </summary>
                                <p className="text__16px">
                                    By creating an account on this website or signing up to receive our newsletter by electronic means, you consent to receiving communications and agree that all agreements, notices, disclosures and all other communications transmitted by electronic means satisfies any legal requirement, including but not limited to the requirement that such communication should be “in writing”.
                                    <br />
                                    <br />
                                    Should you inform HSRC, through a return opt-out email to <Obfuscate email="innovation@hsrc.ac.za" /> (in the case of auto-generated system email) or the opt-out link (in the case of CeSTII email newsletters), that you do not want us to use your information as a basis for further contact with you or for any other purpose, we will not do so.

                                    <br />
                                    <br />

                                </p>
                            </details>
                        </div>


                        <div id="contact" className={styles.question_div} >
                            <details>
                                <summary className="text__18px">
                                    How to contact us
                                </summary>
                                <p className="text__16px">
                                    If you wish to access, correct or update information which HSRC has collected about you or exercise any of your other rights related to your  information, you can contact <Obfuscate email="innovation@hsrc.ac.za" />.
                                    <br />
                                    <br />

                                </p>
                            </details>
                        </div>
                    </div>


















                </div>
                < Separator size="100%" />
                <Contact />

                <Separator size="100%" />
                <Footer />
            </div>
        )
    }
}

export default ConfidentialityQuestions;
